import dayjs from 'dayjs';

// Same as in portal-frontend, should migrate the one from there
export const formatTime = (dateTime: dayjs.Dayjs, region = 'enAU') => {
	if (region === 'enUS') {
		return dateTime.format('hh:mm:ss A');
	}
	return dateTime.format('HH:mm:ss Z');
};
